import { render, staticRenderFns } from "./ShoppingCartPage.vue?vue&type=template&id=77966410&scoped=true"
import script from "./ShoppingCartPage.vue?vue&type=script&lang=ts"
export * from "./ShoppingCartPage.vue?vue&type=script&lang=ts"
import style0 from "./ShoppingCartPage.vue?vue&type=style&index=0&id=77966410&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77966410",
  null
  
)

export default component.exports